/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepValidationException } from './AutoTestStepValidationException';
import { BaseError } from './BaseError';
import { CourseUserLimitExceededException } from './CourseUserLimitExceededException';
import { DisabledSettingException } from './DisabledSettingException';
import { FailedToSendEmailException } from './FailedToSendEmailException';
import { FirstPhaseLTILaunchException } from './FirstPhaseLTILaunchException';
import { IgnoredFilesException } from './IgnoredFilesException';
import { InvalidGroupException } from './InvalidGroupException';
import { InvalidIOCasesException } from './InvalidIOCasesException';
import { InvalidOptionsException } from './InvalidOptionsException';
import { MissingCookieError } from './MissingCookieError';
import { ParseAPIException } from './ParseAPIException';
import { PermissionException } from './PermissionException';
import { RateLimitExceededException } from './RateLimitExceededException';
import { RepositoryConnectionLimitReachedException } from './RepositoryConnectionLimitReachedException';
import { TierRestrictedException } from './TierRestrictedException';
import { TokenRevokedException } from './TokenRevokedException';
import { UpgradedLTIProviderException } from './UpgradedLTIProviderException';
import { WeakPasswordException } from './WeakPasswordException';
const AnyErrorParser = /* #__PURE__ */ /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ codecOneOf([
    CourseUserLimitExceededException,
    IgnoredFilesException,
    TierRestrictedException,
    DisabledSettingException,
    InvalidIOCasesException,
    PermissionException,
    FailedToSendEmailException,
    WeakPasswordException,
    ParseAPIException,
    RateLimitExceededException,
    AutoTestStepValidationException,
    InvalidGroupException,
    RepositoryConnectionLimitReachedException,
    TokenRevokedException,
    MissingCookieError,
    InvalidOptionsException,
    UpgradedLTIProviderException,
    FirstPhaseLTILaunchException,
    BaseError,
]));
export const AnyError = AnyErrorParser;
